
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { AzureTableDataset } from 'app/model/dataset/azure-table.dataset';
import { AzureStorageLinkedService } from 'app/model/linkedservice/azure-storage.linkedservice';
import { AzureTableStorageLinkedService } from '../../model/linkedservice/azure-table-storage.linkedservice';
import { Constants } from '../../shared/shared-constants';
import { format } from 'app/shared/utils/string.util';
import { maxConcurrentConnectionsMetadata } from '../consts/metadata-consts';
import { ColumnType } from 'app/shared/utils/column-type.util';

export const azureTableMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(AzureTableDataset).name,
    supportLinkedServiceTypes: [Metamodel.modelFor(AzureStorageLinkedService).name, Metamodel.modelFor(AzureTableStorageLinkedService).name],
    displayName: stringResources.AzureTableStorage_DisplayText,
    datasetKind: 'table',
    isSource: true,
    isSink: true,
    icon: {
        className: 'svg-i-100x100-AzureTable'
    },
    isFirstClass: true,
    isTableNameRequired: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Azure'],
    copySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'checkbox',
                bind: 'ignoreTableNotFound',
                label: stringResources.ModelName_IgnoreTableNotFound
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    copySinkControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'writeBatchTimeout',
                label: stringResources.ModelName_WriteBatchTimeout,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_WriteBatchTimeout)
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                inputType: 'number',
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        },
        maxConcurrentConnectionsMetadata
    ],
    supportDataTypes: [
        ColumnType.ByteArray,
        ColumnType.Boolean,
        ColumnType.DateTime,
        ColumnType.DateTimeOffset,
        ColumnType.Double,
        ColumnType.Guid,
        ColumnType.Int32,
        ColumnType.Int64,
        ColumnType.String
    ]
};
